<template>
  <el-main class="layout-agent">
    <el-container>
      <el-header class="header">
        <div class="item" :class="{ active: activeTab === 'marketplace' }" @click="switchTab('marketplace')">
          智能体广场
        </div>
        <div class="item" :class="{ active: activeTab === 'chat' }" @click="switchTab('chat')">
          智能体对话
        </div>
        <div class="item" :class="{ active: activeTab === 'my-agents' }" @click="switchTab('my-agents')">
          我的智能体
        </div>
      </el-header>
      <el-main class="agent-container">
        <!-- 智能体广场 -->
        <agent-marketplace v-if="activeTab === 'marketplace'" @select-agent="handleSelectAgent"
          @switch-tab="switchTab"></agent-marketplace>

        <!-- 智能体对话 -->
        <agent-chat v-if="activeTab === 'chat'" :selected-agent="selectedAgent" :active-tab="activeTab"
          @go-to-marketplace="switchTab('marketplace')" @auto-select-agent="handleAutoSelectAgent"
          ref="agentChat"></agent-chat>

        <!-- 我的智能体 -->
        <my-agents v-if="activeTab === 'my-agents'" @edit-agent="handleEditAgent" @test-agent="handleTestAgent"
          @switch-tab="switchTab"></my-agents>
      </el-main>
    </el-container>
  </el-main>
</template>

<script>
import AgentMarketplace from './components/agent-marketplace.vue'
import AgentChat from './components/agent-chat.vue'
import MyAgents from './components/my-agents.vue'

export default {
  name: 'layout-agent',
  components: {
    AgentMarketplace,
    AgentChat,
    MyAgents
  },

  data() {
    return {
      activeTab: 'marketplace', // 默认显示智能体广场
      selectedAgent: null // 选中的智能体
    }
  },

  mounted() {
    // 从路由参数获取tab，支持跳转后自动切换tab
    const tab = this.$route.query.tab
    if (tab && ['marketplace', 'chat', 'my-agents'].includes(tab)) {
      this.activeTab = tab
    }
  },

  methods: {
    async switchTab(tab) {
      this.activeTab = tab
      // 当切换到chat tab时，如果没有选中智能体，则加载对话列表
      if (tab === 'chat' && !this.selectedAgent) {
        this.$nextTick(() => {
          if (this.$refs.agentChat) {
            this.$refs.agentChat.initializeChat()
          }
        })
      }
    },

    handleSelectAgent(agent) {

      this.selectedAgent = agent
      this.activeTab = 'chat' // 选择智能体后跳转到对话页面

      // 确保agent-chat组件重新初始化
      this.$nextTick(() => {
        if (this.$refs.agentChat) {
          this.$refs.agentChat.initializeChat()
        }
      })
    },

    handleAutoSelectAgent(agent) {
      this.selectedAgent = agent
    },

    handleEditAgent(agent) {
      // 处理编辑智能体逻辑
      console.log('编辑智能体:', agent)
    },

    handleTestAgent(agent) {
      this.selectedAgent = agent
      this.activeTab = 'chat' // 测试智能体时跳转到对话页面
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-agent {
  padding: 0 !important;
  height: 100%;

  .header {
    display: flex;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
    padding: 0 20px;

    .item {
      padding: 16px 24px;
      cursor: pointer;
      font-size: 16px;
      color: #666;
      border-bottom: 2px solid transparent;
      transition: all 0.3s ease;

      &:hover {
        color: #7848f1;
      }

      &.active {
        color: #7848f1;
        border-bottom-color: #7848f1;
        font-weight: 500;
      }
    }
  }

  .agent-container {
    flex: 1;
    height: calc(100vh - 120px);
    overflow: hidden;
    padding: 0;
  }
}
</style>